<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import NextInput from 'dashboard/components-next/input/Input.vue';

// Input for create_reminder / create_calendar_event actions.
// Emits action_params = [title, days, hours, minutes] — the title plus the
// Days/Hours/Minutes offset from "now" used for the trigger/start time.
const props = defineProps({
  modelValue: {
    type: [Array, String],
    default: () => [],
  },
});
const emit = defineEmits(['update:modelValue']);

const { t } = useI18n();

const params = computed(() =>
  Array.isArray(props.modelValue) ? props.modelValue : []
);

const update = (index, value) => {
  const next = [...params.value];
  next[index] = value;
  emit('update:modelValue', next);
};

const title = computed(() => params.value[0] ?? '');
const days = computed(() => params.value[1] ?? '');
const hours = computed(() => params.value[2] ?? '');
const minutes = computed(() => params.value[3] ?? '');

const durationFieldClass =
  'w-full h-9 px-3 rounded-lg text-sm bg-n-alpha-1 text-n-slate-12 border border-n-weak outline-none focus:border-n-brand';
</script>

<template>
  <div class="flex flex-col w-full gap-2">
    <NextInput
      :model-value="title"
      size="sm"
      :placeholder="t('AUTOMATION.ACTION.SCHEDULED_CREATE.TITLE_PLACEHOLDER')"
      @update:model-value="value => update(0, value)"
    />
    <div class="flex items-end gap-2">
      <label class="flex flex-col flex-1 gap-1">
        <span class="text-xs text-n-slate-11">
          {{ t('AUTOMATION.ACTION.SCHEDULED_CREATE.DAYS') }}
        </span>
        <input
          :value="days"
          type="number"
          min="0"
          :class="durationFieldClass"
          @input="event => update(1, event.target.value)"
        />
      </label>
      <label class="flex flex-col flex-1 gap-1">
        <span class="text-xs text-n-slate-11">
          {{ t('AUTOMATION.ACTION.SCHEDULED_CREATE.HOURS') }}
        </span>
        <input
          :value="hours"
          type="number"
          min="0"
          :class="durationFieldClass"
          @input="event => update(2, event.target.value)"
        />
      </label>
      <label class="flex flex-col flex-1 gap-1">
        <span class="text-xs text-n-slate-11">
          {{ t('AUTOMATION.ACTION.SCHEDULED_CREATE.MINUTES') }}
        </span>
        <input
          :value="minutes"
          type="number"
          min="0"
          :class="durationFieldClass"
          @input="event => update(3, event.target.value)"
        />
      </label>
    </div>
    <span class="text-xs text-n-slate-10">
      {{ t('AUTOMATION.ACTION.SCHEDULED_CREATE.HINT') }}
    </span>
  </div>
</template>
